import { computed, h, defineComponent, onBeforeMount, ref } from 'vue';
import { IMAGE_REPORT_MAX_HEIGHT } from '@/entities/inspection/constants';
import { resizeBase64Img } from '@/services/issueTemplate/resizeBase64Img';

interface ImageDrawingProps {
  image: string | null;
  drawing: string | null;
  isThumbnail: boolean;
}

export default defineComponent<ImageDrawingProps>({
  name: 'ImageDrawing',
  props: {
    image: {
      type: String,
      default: null,
    },
    drawing: {
      type: String,
      default: null,
    },
    isThumbnail: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const thumbnailClass = computed(() => props.isThumbnail ? 'inspection-report__image-drawing-thumbnail' : '');

    const resizedImage = ref('');

    onBeforeMount(async () => {
      const maxHeight = props.isThumbnail ? IMAGE_REPORT_MAX_HEIGHT.THUMBNAIL : IMAGE_REPORT_MAX_HEIGHT.REGULAR;
      try {
        const result = await resizeBase64Img(props.image!, maxHeight);
        resizedImage.value = result;
      } catch (e) {
        console.error(e);
        resizedImage.value = props.image || '';
      }
    });

    return function render() {
      return h('img', {
        class: `${thumbnailClass.value}`,
        style: {
          'background-image': props.drawing && props.image ? `url(${resizedImage.value})` : 'null',
        },
        attrs: {
          src: props.drawing ? props.drawing : resizedImage.value,
        },
        // @ts-ignore
        on: ctx.listeners,
      });
    };
  },
});
